import * as stylex from "@stylexjs/stylex";
import { spacing, colors } from "@softmax/design-system/tokens.stylex";

export function Arrow({ at }: { readonly at: "first" | "second" }) {
  return (
    <div
      data-figure-arrow="true"
      {...stylex.props(styles.arrowBox, arrowPlacement[at])}
    >
      <svg
        width="30"
        height="16"
        viewBox="0 0 30 16"
        aria-hidden="true"
        {...stylex.props(styles.arrow)}
      >
        <line
          x1="0"
          y1="8"
          x2="19"
          y2="8"
          stroke="currentColor"
          strokeWidth={1}
        />
        <polygon points="30,8 19,4 19,12" fill="currentColor" />
      </svg>
    </div>
  );
}

const arrowPlacement = stylex.create({
  first: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 2 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 1 },
  },
  second: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 4 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 1 },
  },
});

const styles = stylex.create({
  arrowBox: {
    display: "flex",
    height: {
      default: 36,
      "@container (min-width: 560px)": 224,
      "@container (min-width: 700px)": 260,
    },
    width: {
      default: "100%",
      "@container (min-width: 560px)": 20,
      "@container (min-width: 700px)": 32,
    },
    alignItems: "center",
    justifyContent: "center",
    paddingBlock: {
      default: spacing.space4,
      "@container (min-width: 560px)": 0,
    },
  },
  arrow: {
    transform: {
      default: "rotate(90deg)",
      "@container (min-width: 560px)": "rotate(0deg)",
    },
    color: colors.foreground,
  },
});
